import { Component, Input } from '@angular/core';
import { CampaignsService } from '../../services';
import { Router } from '@angular/router';

@Component({
  selector: 'app-new-node',
  templateUrl: './app-new-node.component.html',
  providers: [CampaignsService]
})

export class AppNewNodeComponent {

  @Input() type: string;
  @Input() label = 'New';
  constructor(
    private router: Router,
    private campaignsService: CampaignsService) {
  }

  public async createAndRedirect(event: Event) {
    event.preventDefault();
    const data = await this.campaignsService.createIdCampaign(this.type).toPromise();
    if (data) {
      setTimeout(() => {
        this.router.navigate(['/' + this.type + '/' + data.id + '/edit']);
      }, 500);
    }
  }

}
